import { useEffect } from 'react'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import ButtonComponent, { BUTTON_HEIGHT_32, ButtonArrow } from '../../Button'
import { useWidgetContext } from '../Widget.hooks'

import { QA_NAME_WIDGET_HEADER_EXPAND_BTN } from './WidgetHeaderContentActionsExpandButton.constants'

function WidgetHeaderContentActionsExpandButton({
  Button = ButtonComponent.Flat,
  closeTooltipText = 'Common.WidgetHeaderExpandButtonCloseTooltipKey',
  height = BUTTON_HEIGHT_32,
  isInline = false,
  isSquare = true,
  openTooltipText = 'Common.WidgetHeaderExpandButtonOpenTooltipKey',
  qaName = QA_NAME_WIDGET_HEADER_EXPAND_BTN,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  ...restProps
}) {
  const { handleToggleExpanded, isExpanded, registerExpandButton } =
    useWidgetContext()

  useEffect(() => registerExpandButton(), [])

  return (
    <ButtonArrow
      {...restProps}
      Button={Button}
      closeTooltipText={closeTooltipText}
      height={height}
      isInline={isInline}
      isOpen={isExpanded}
      isSquare={isSquare}
      openTooltipText={openTooltipText}
      qaName={qaName}
      tooltipPlacement={tooltipPlacement}
      onClick={handleToggleExpanded}
    />
  )
}

export default WidgetHeaderContentActionsExpandButton
